export const FILTER_SLIDEOUT_COLORS = {
  primary: '#2173FF',
  primaryBg: '#E9F1FF',
  primaryText: '#001740',
  borderGray: '#5C5C5C',
  textDark: '#2a2a2a',
  bgLight: '#f2f2f2',
  textMedium: '#666',
  placeholderText: '#bababa',
};

export const FILTER_SLIDEOUT_WIDTH = {
  s: 'w-[420px] max-w-[calc(100vw-1rem)]',
  m: 'w-[600px] max-w-[calc(100vw-1rem)]',
};

export const FILTER_SLIDEOUT_PANEL = [
  'rounded-l-2xl border-l border-edge',
  'shadow-[-24px_-24px_60px_0_rgba(0,0,0,0.08)] dark:shadow-none',
].join(' ');

export const FILTER_SLIDEOUT_LAYOUT = 'flex h-full min-h-0 flex-col px-6 py-8';

export const FILTER_SLIDEOUT_HEADER = [
  'flex h-16 shrink-0 items-center justify-between',
  'text-[18px] font-semibold leading-none tracking-[0.25px] text-content',
].join(' ');

export const FILTER_SLIDEOUT_CLOSE_BUTTON = [
  'inline-flex h-10 w-10 shrink-0 items-center justify-center rounded',
  'text-content transition-colors hover:bg-surface-hover',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50',
].join(' ');

export const FILTER_SLIDEOUT_BODY = [
  'min-h-0 flex-1 overflow-y-auto overflow-x-hidden',
  'scrollbar-aimsos-auto-sm',
].join(' ');

export const FILTER_SLIDEOUT_BODY_INNER = 'flex w-full flex-col gap-4 pb-4';

export const FILTER_SLIDEOUT_FOOTER = [
  'flex shrink-0 items-center justify-end gap-3 border-t border-edge',
  'pt-4',
].join(' ');

export const FILTER_SLIDEOUT_SECTION = 'flex w-full flex-col gap-3';
export const FILTER_SLIDEOUT_SECTION_DISABLED = 'pointer-events-none opacity-50';

export const FILTER_SLIDEOUT_SECTION_HEADER = [
  'flex h-7 w-full items-center justify-between gap-2',
  'text-sm font-medium leading-5 text-content',
].join(' ');

export const FILTER_SLIDEOUT_SECTION_HEADER_BUTTON = [
  'flex min-w-0 flex-1 items-center gap-2 text-left',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50',
].join(' ');

export const FILTER_SLIDEOUT_CLEAR_BUTTON = [
  'h-7 shrink-0 px-3 rounded text-xs font-medium leading-5 text-[#2a2a2a] dark:text-white',
  'transition-colors hover:bg-surface-hover',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50',
].join(' ');

export const FILTER_SLIDEOUT_COUNT_BADGE = [
  'inline-flex h-5 shrink-0 items-center justify-center rounded-lg border border-[#2173FF]',
  'bg-[#E9F1FF] px-2 text-xs font-medium leading-none text-[#001740]',
].join(' ');

export const FILTER_SLIDEOUT_CHEVRON_BUTTON = [
  'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded',
  'text-content transition-colors hover:bg-surface-hover',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50',
].join(' ');

export const FILTER_SLIDEOUT_OPTION_LIST = 'flex w-full flex-col gap-2';
export const FILTER_SLIDEOUT_OPTION_ROW = [
  'flex min-h-6 w-full items-center gap-2 text-sm font-medium leading-5 text-content-secondary',
].join(' ');

export const FILTER_SLIDEOUT_DISCLOSURE = [
  'inline-flex h-6 items-center gap-1 rounded px-3 text-xs font-medium leading-5 text-content',
  'transition-colors hover:bg-surface-hover',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50',
].join(' ');

export const FILTER_SLIDEOUT_CHIP_LIST = 'flex flex-wrap items-start gap-2';
export const FILTER_SLIDEOUT_CHIP = [
  'inline-flex h-5 max-w-[120px] shrink-0 items-center justify-center rounded-full border border-[#5C5C5C]',
  'bg-surface px-2 text-xs font-medium leading-5 text-content',
  'transition-colors hover:bg-surface-hover',
].join(' ');
export const FILTER_SLIDEOUT_CHIP_ACTIVE = [
  'border-[#2173FF] bg-[#2173FF]/10 text-[#001740] shadow-[0_0_0_2px_rgba(33,115,255,0.12)]',
  'dark:border-blue-400 dark:bg-blue-400/15 dark:text-blue-100 dark:shadow-[0_0_0_2px_rgba(96,165,250,0.18)]',
].join(' ');

export const FILTER_SLIDEOUT_TEXT_FIELD = [
  'h-8 w-full rounded-lg border border-[#5C5C5C] bg-surface px-4 text-sm font-medium leading-5 text-content',
  'placeholder:text-content-faint',
  'focus:border-[#2173FF] focus:outline-none focus:ring-1 focus:ring-[#2173FF]/50',
].join(' ');

export const FILTER_SLIDEOUT_DATE_FIELD = [
  FILTER_SLIDEOUT_TEXT_FIELD,
  'pl-10',
].join(' ');

export const FILTER_SLIDEOUT_INLINE_ERROR = 'text-xs font-medium leading-5 text-red-600';
